import { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Inbox, CalendarClock, Briefcase, Users, Plus, Settings } from "lucide-react";
import { DemandeFormDialog } from "./DemandeFormDialog";

const NAV = [
  { to: "/", label: "Tableau de bord", icon: LayoutDashboard, id: "dashboard", end: true },
  { to: "/demandes", label: "Demandes", icon: Inbox, id: "demandes" },
  { to: "/agenda", label: "RDV & relances", icon: CalendarClock, id: "agenda" },
  { to: "/missions", label: "Missions", icon: Briefcase, id: "missions" },
  { to: "/clients", label: "Clients & échanges", icon: Users, id: "clients" },
  { to: "/reglages", label: "Réglages", icon: Settings, id: "reglages" },
];

const Brand = ({ full = false }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    {full ? (
      <img src="/logo-full.png" alt="KARU'CARA Consulting" className="w-44" data-testid="brand-logo-img" />
    ) : (
      <>
        <img src="/logo-mark.png" alt="KARU'CARA Consulting" className="h-10 w-auto" data-testid="brand-logo-img" />
        <div className="leading-tight">
          <p className="font-display text-base font-semibold tracking-wide">KARU'CARA</p>
          <p className="text-[11px] uppercase tracking-[0.2em] text-[var(--kc-gold)]">Consulting</p>
        </div>
      </>
    )}
  </div>
);

export default function Layout() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const link = ({ isActive }) =>
    `flex items-center gap-3 rounded-md px-3 py-2.5 text-sm transition-colors ${isActive ? "bg-white/10 text-white" : "text-white/60 hover:bg-white/5 hover:text-white"}`;

  return (
    <div className="min-h-screen bg-[var(--kc-bg)]">
      <aside className="fixed inset-y-0 left-0 z-30 hidden w-64 flex-col bg-[var(--kc-navy)] px-5 py-5 text-white lg:flex">
        <div className="-mx-2 flex justify-center"><Brand full /></div>
        <button onClick={() => setOpen(true)} data-testid="create-demande-button"
          className="mt-4 flex items-center justify-center gap-2 rounded-md bg-[var(--kc-gold)] px-4 py-2.5 text-sm font-semibold text-[var(--kc-navy)] transition-colors hover:bg-[var(--kc-gold-light)]">
          <Plus className="h-4 w-4" /> Nouvelle demande
        </button>
        <nav className="mt-8 space-y-1">
          {NAV.map(({ to, label, icon: Icon, id, end }) => (
            <NavLink key={to} to={to} end={end} className={link} data-testid={`nav-${id}-link`}><Icon className="h-4 w-4" />{label}</NavLink>
          ))}
        </nav>
        <div className="mt-auto border-t border-white/10 pt-5 text-xs text-white/40">
          <p>Espace dirigeant</p>
          <p className="mt-1">Audit · Management de projet · Stratégie marketing</p>
        </div>
      </aside>

      <header className="sticky top-0 z-30 flex items-center gap-3 overflow-x-auto bg-[var(--kc-navy)] px-4 py-3 text-white lg:hidden">
        <Brand />
        <nav className="ml-auto flex gap-1">
          {NAV.map(({ to, icon: Icon, id, end }) => (
            <NavLink key={to} to={to} end={end} className={link} data-testid={`mobile-nav-${id}-link`}><Icon className="h-4 w-4" /></NavLink>
          ))}
          <button onClick={() => setOpen(true)} className="rounded-md bg-[var(--kc-gold)] p-2.5 text-[var(--kc-navy)]" data-testid="mobile-create-demande-button"><Plus className="h-4 w-4" /></button>
        </nav>
      </header>

      <main className="lg:pl-64">
        <div className="mx-auto max-w-[1400px] px-5 py-8 sm:px-8 lg:px-12 lg:py-12">
          <Outlet context={{ openNewDemande: () => setOpen(true) }} />
        </div>
      </main>
      <DemandeFormDialog open={open} onOpenChange={setOpen} onSaved={(d) => navigate(`/demandes/${d.id}`)} />
    </div>
  );
}
